
import VuePicker from 'vue-pickers'
import { Component, Prop, Vue } from 'vue-property-decorator'
import { getDisplayName, getuserCurrentApp } from '@/utils/cookies.ts'
import { AppModule, DeviceType } from '@/store/modules/app'
import { UserModule } from '@/store/modules/user'
import { ISSUESAPI } from '@/api/issues'

@Component({
  components: {
    VuePicker
  }
})

export default class AppMain extends Vue {
  @Prop({ default: false }) private editForm!: any // 编辑表单时用到的表单数据
  private editId = 0
  private isDisableSubmit = false // 避免重复触发提交按钮
  private roomTypeOptions = [] // 直播间options
  private roomTimes = [] // 直播时间段options
  private handlerList = [] // 受理人options
  private issueTypesOptions = [] // 问题类型
  // 联动下拉框手机端
  private pickerRoomVisible = false // 点击直播间文本框，显示picker联动
  private pickerIssueVisible = false
  private showToolbar = true
  private defaultRoomIndex = [] as number[] // 默认联动定位，从0开始，0代表第一行
  private defaultIssueIndex = [] as number[]
  private liveRoomCn = '' // 手机端直播间文本框内容展示
  private liveIssueCn = '' // 移动端：问题类型内容

  formData = {
    teacherName: this.username || '',
    issueDate: new Date(),
    liveRoom: [] as any, // 用来存储提交用的id
    issueType: [] as any,
    liveTimeRange: '',
    isLiveInfluenced: 0,
    describe: '',
    handler: 0
  }

  formRules: object = {
    teacherName: [{ required: true }],
    issueDate: [{ required: true }],
    liveRoom: [{ required: true, message: '请选择直播间', trigger: 'change' }],
    issueType: [{ required: true, message: '请选择问题类型', trigger: 'change' }],
    liveTimeRange: [{ required: true, message: '请选择直播时间段', trigger: 'change' }],
    isLiveInfluenced: [{ required: true, message: '请选择是否影响直播', trigger: 'change' }],
    describe: [{ required: true, message: '请输入问题描述', trigger: 'blur' }],
    handler: [{ required: true, message: '请选择工单受理人', trigger: 'change' }]
  }

  pickerOptions: object = {
    disabledDate(time: any) {
      return time.getTime() > Date.now()
    }
  }

  get userCurrentApp() {
    return getuserCurrentApp()
  }

  get isEdit() {
    return !!this.editForm
  }

  get device() {
    return AppModule.device
  }

  get classObj() {
    return {
      mobile: this.device === DeviceType.Mobile
    }
  }

  get username() {
    return getDisplayName()
  }

  mounted() {
    this.getRooms() // 获取主讲直播间
    this.getRoomTimes() // 获取主讲直播时间段
    this.getHandlerList() // 获取主讲工单受理人列表
    if (this.isEdit) {
      this.assignFormdata()
    }
  }

  // 判断是否是创建人，受理人列表中禁用掉创建人
  private isCreater(item: any) {
    return item.workcode === UserModule.workcode
  }

  // 获取主讲直播间
  private async getRooms() {
    let { data } = await ISSUESAPI.getRooms()
    if (this.classObj.mobile) { // 手机端插件数据结构需要用value
      data = JSON.parse(JSON.stringify(data).replace(/"id"/g, '"value"'))
    }
    this.roomTypeOptions = data
    // 移动端：编辑时定位直播间级联的默认位置
    if (this.classObj.mobile && this.isEdit) {
      this.roomTypeOptions.some((roomType: any, index1: number) => {
        if (roomType.value === 'room_type_' + this.editForm.live_room.room_type.id) {
          roomType.children.some((area: any, index2: number) => {
            if (area.value === 'area_' + this.editForm.live_room.area_type.id) {
              area.children.some((item: any, index3: number) => {
                if (item.value === this.editForm.live_room.id) {
                  this.defaultRoomIndex = [index1, index2, index3]
                }
              })
            }
          })
        }
      })
    }
  }

  // 获取主讲直播时间段
  private async getRoomTimes() {
    const { data } = await ISSUESAPI.getRoomTimes()
    this.roomTimes = data.lists
  }

  // 获取主讲工单受理人列表
  private async getHandlerList() {
    // const { data } = await ISSUESAPI.getHandlerList()
    // this.handlerList = data.list
  }

  // web端：切换直播间
  handleLiveRoomChange() {
    (this.$refs.issueType as any).$refs.panel.activePath = [] // 需要先把问题类型级联的高亮去掉，否则会报错
    this.getIssueType(this.formData.liveRoom[0])
  }

  // 移动端：直播间联动确认
  confirmChangeRoom(res: any) {
    const liveRoom: string[] = []
    res.map((item: { label: string }) => {
      liveRoom.push(item.label)
    })
    this.liveRoomCn = liveRoom.join('/')
    this.formData.liveRoom = [res[0].value, res[1].value, res[2].value]
    // 清空上一次选择的问题类型
    this.liveIssueCn = ''
    this.formData.issueType = []
    this.getIssueType(res[0].value)
  }

  // 移动端：问题类型点击事件
  handleClickIssueType() {
    if (this.liveRoomCn === '') {
      this.$message.warning('请先选择直播间')
    } else {
      this.pickerIssueVisible = true
    }
  }

  // 获取主讲问题类型
  private async getIssueType(roomId: string) {
    let { data } = await ISSUESAPI.getIssueType(roomId)
    if (this.classObj.mobile) { // 手机端插件数据结构需要用value
      data = JSON.parse(JSON.stringify(data).replace(/"id"/g, '"value"'))
    }
    this.issueTypesOptions = data
    // 移动端：编辑时定位直播间级联的默认位置
    if (this.classObj.mobile && this.isEdit) {
      this.issueTypesOptions.some((parent: any, index1: number) => {
        if (parent.value === this.editForm.issue_type.parent_issue_type.id) {
          parent.children.some((item: any, index2: number) => {
            if (item.value === this.editForm.issue_type.id) {
              this.defaultIssueIndex = [index1, index2]
            }
          })
        }
      })
    }
  }

  // 移动端：问题类型联动确认
  confirmChangeIssue(res: any) {
    const issueType: string[] = []
    res.map((item: { label: string }) => {
      issueType.push(item.label)
    })
    this.liveIssueCn = issueType.join('/')
    this.formData.issueType = [res[0].value, res[1].value]
  }

  assignFormdata() {
    this.editId = this.editForm.id
    const editLiveRoom: any = ['room_type_' + this.editForm.live_room.room_type.id, 'area_' + this.editForm.live_room.area_type.id, this.editForm.live_room.id]
    const editIssueType: any = [this.editForm.issue_type.parent_issue_type.id, this.editForm.issue_type.id]
    this.formData = {
      teacherName: this.editForm.creator.name,
      issueDate: this.editForm.create_time.split(' ')[0],
      liveRoom: editLiveRoom,
      issueType: editIssueType,
      liveTimeRange: this.editForm.live_time_range.id,
      isLiveInfluenced: this.editForm.is_live_influenced,
      describe: this.editForm.describe,
      handler: this.editForm.accept_user.id
    }
    // 移动端直播间文本框显示的内容
    this.liveRoomCn = this.editForm.live_room.room_type.name + '/' + this.editForm.live_room.area_type.name + '/' + this.editForm.live_room.name // 手机端文本框内容展示
    this.liveIssueCn = this.editForm.issue_type.parent_issue_type.name + '/' + this.editForm.issue_type.name
    this.getIssueType(editLiveRoom[0])
  }

  handleSubmit(formName: string) {
    const form: any = this.$refs[formName]
    form.validate(async (valid: boolean) => {
      if (valid) {
        this.isDisableSubmit = true
        await ISSUESAPI.addIssue({
          live_room: this.formData.liveRoom[2],
          issue_type: this.formData.issueType[1],
          live_time_range: this.formData.liveTimeRange,
          describe: this.formData.describe,
          is_live_influenced: this.formData.isLiveInfluenced,
          accept_user: this.formData.handler
        }).then((res) => {
          if (res.stat === 1) {
            this.$message.success('提交成功')
            this.handleResetForm(formName)
            this.$router.push({ path: '/home' })
          }
          this.isDisableSubmit = false
        }).catch(() => {
          this.isDisableSubmit = false
        })
      } else {
        console.log('error submit!!')
        return false
      }
    })
  }

  handleEditSubmit(formName: string) {
    const form: any = this.$refs[formName]
    form.validate(async (valid: boolean) => {
      if (valid) {
        this.isDisableSubmit = true
        await ISSUESAPI.editIssue({
          id: this.editId,
          live_room: this.formData.liveRoom[2],
          issue_type: this.formData.issueType[1],
          live_time_range: this.formData.liveTimeRange,
          describe: this.formData.describe,
          is_live_influenced: this.formData.isLiveInfluenced,
          accept_user: this.formData.handler
        }).then((res) => {
          if (res.stat === 1) {
            this.$emit('handleSuccess', res)
            this.$emit('handleCloseDialog')
          }
          this.isDisableSubmit = false
        }).catch(() => {
          this.isDisableSubmit = false
        })
      } else {
        console.log('error submit!!')
        return false
      }
    })
  }

  handleResetForm(formName: string) {
    this.liveRoomCn = ''
    this.liveIssueCn = ''
    const form: any = this.$refs[formName]
    form.resetFields()
  }
}
